import Format from '@admin/components/format'
import PropTypes from 'prop-types'
import React from 'react'

const SignupPageAddonToken = (props) => (
  <div>
    { props.discount_price ?
      <><span className="alert strikethrough"><Format value={ props.price } format="money" /></span> <Format value={ props.discount_price } format="money" /></> :
      <>{ <Format value={ props.price } format="money" /> }</>
    }
  </div>
)

SignupPageAddonToken.propTypes = {
  discount_price: PropTypes.number,
  price: PropTypes.number
}

export default SignupPageAddonToken
